/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Project_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a new project with a name, optional description, and instructions to guide AI interactions." |
*
* @param {Create_Project_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_description = /** @type {((inputs?: Create_Project_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle ein neues Projekt mit Namen, optionaler Beschreibung und Anweisungen, um die KI-Interaktionen zu steuern.")
	return /** @type {LocalizedString} */ ("Create a new project with a name, optional description, and instructions to guide AI interactions.")
});